import { GetServerSideProps, GetServerSidePropsContext, NextPage } from 'next';
import { useRouter } from 'next/router';
import { useSearchParams } from 'next/navigation';

import React from 'react';
import { FlexRowCenter } from 'components/flex-box';
import SignIn from 'pages-sections/sessions/Sign-in';
import { adminAuth } from 'utils/1kmwine-firebase-admin';
import { SESSION_TOKEN } from 'config';
import { logger } from 'firebase-functions';
import { Box } from '@mui/material';
import Footer from '../src/footer/Footer';

/**
 * 로그인 페이지
 * @constructor
 */
const SignInPage: NextPage = () => {
  const router = useRouter();
  const searchParams = useSearchParams();
  let targetUrl = searchParams.get('targetUrl');
  targetUrl = targetUrl && targetUrl !== '/my/withdrawal' ? targetUrl : '/';

  const onSignInSuccess = React.useCallback(async (): Promise<any> => {
    // 로그인 후 이동할 페이지 지정, targetUrl
    await router.replace('/my');
  }, [router, targetUrl]);

  return (
    <Box
      position="relative"
      display="flex"
      flexDirection="column"
      minHeight="calc(var(--vh, 1vh) * 100)"
      justifyContent="center"
    >
      {/*<FlexRowCenter flexDirection="column" minHeight="100vh" bgcolor="#F7F9FC">*/}
      {/*  <SignIn onSuccess={onSignInSuccess} targetUrl={targetUrl ?? '/'} />*/}
      {/*</FlexRowCenter>*/}

      <FlexRowCenter className="section-after-sticky" flexGrow={1} position="relative" bgcolor="#F7F9FC">
        <SignIn onSuccess={onSignInSuccess} targetUrl={targetUrl ?? '/'} />
      </FlexRowCenter>
      {/* FOOTER */}
      <Footer color="#FFF" />
    </Box>
  );
};

export const getServerSideProps = (async (ctx: GetServerSidePropsContext) => {
  const { [SESSION_TOKEN]: token } = ctx.req.cookies;
  // 로그인한 사용자의 요청
  if (token) {
    try {
      // 유효하지 않은 토큰이나 만료된 토큰이라면 에러 발생
      await adminAuth.verifyIdToken(token, true);

      // 로그인 되어있는 사용자라면 홈 화면으로 이동
      return {
        redirect: {
          permanent: false,
          destination: '/my'
        },
        props: {}
      };
    } catch (err) {
      logger.warn('유효하지 않은 토큰을 가진 사용자의 로그인화면 호출', { token });
    }
  }

  return { props: {} };
}) satisfies GetServerSideProps<{
  // signedInUser: SignedInUser;
}>;

export default SignInPage;
